import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Card, { CardSection } from '@lightspeed/cirrus-card';
import { IconWarning } from '@lightspeed/flame/Icon/Warning';
import Text from '@lightspeed/cirrus-text';
import Group from '@lightspeed/cirrus-group';

import Layout, { LayoutContent } from 'cirrus/Layout';

const STRINGS = {
  ERROR: {
    SECTION_UNAVAILABLE: {
      TITLE: 'Section Unavailable',
      MESSAGE:
        "This section is currently unavailable. We're aware of the situation, please retry later.",
    },
  },
};
const iconSize = '1.125rem';

const ViewError = ({ isErroring, children }) =>
  isErroring ? (
    <Layout>
      <LayoutContent>
        <Card large>
          <CardSection>
            <Group type="vertical">
              <div className="cr-flex cr-width-full cr-items-center">
                <div className="cr-mr-2 cr-width-full" style={{ width: iconSize }}>
                  <IconWarning size={iconSize} color="maple" />
                </div>
                <Text heading3>{STRINGS.ERROR.SECTION_UNAVAILABLE.TITLE}</Text>
              </div>
              <Group>
                <Text bodySmall dimmed>
                  {STRINGS.ERROR.SECTION_UNAVAILABLE.MESSAGE}
                </Text>
              </Group>
            </Group>
          </CardSection>
        </Card>
      </LayoutContent>
    </Layout>
  ) : (
    <Fragment>{children}</Fragment>
  );

ViewError.propTypes = {
  isErroring: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

ViewError.defaultProps = {
  isErroring: false,
};

export default ViewError;
